import { Section } from "design-system/molecules/Section"
import { MetricGroup } from "modules/backoffice/hooks/bi/useBiMetrics"
import { MetricChartCard } from "./MetricChartCard"

type MetricsSectionProps = {
  title: string
  metricGroups: MetricGroup[]
  isPending: boolean
}

export const MetricsSection = ({ title, metricGroups, isPending }: MetricsSectionProps) => {
  if (metricGroups.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      <Section title={title} />
      <div className="grid grid-cols-1 2xl:grid-cols-2 gap-6">
        {metricGroups.map((group, index) => {
          return (
            <MetricChartCard
              key={group.field ? `${group.category}-${group.field}` : `${group.category}-${index}`}
              title={group.title}
              description={group.description}
              chartData={group.chartData}
              chartConfig={group.chartConfig}
              hasData={group.hasData}
              isPending={isPending}
              type={group.type}
              category={group.category}
              field={group.field}
            />
          )
        })}
      </div>
    </div>
  )
}
